import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	position: relative;

	label {
		font-size: 14px;
		font-weight: 500;
		color: ${tokens.color_gray_dark};
	}
`;

export const Wrapper = styled.div``;

export const ContainerProgressBar = styled.div`
	top: -24px;
	right: 12px;
	position: absolute;

	div {
		background-color: white;
	}
`;

export const ContainerHeader = styled.div`
	display: flex;
	gap: 5px;
`;

export const ContainerTextHeader = styled.div`
	h2 {
		color: ${tokens.color_gray_dark};
		font-family: ${tokens.font_family_primary};
		font-weight: 600;
		font-size: 16px;
	}

	h3 {
		color: ${tokens.color_gray_dark};
		font-family: ${tokens.font_family_primary};
		font-weight: 600;
		font-size: 12px;
	}
`;

export const ContainerContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	color: ${tokens.color_gray_dark};
	font-family: ${tokens.font_family_primary};
	font-size: 12px;
	padding-top: 12px;

	button {
		padding: 0;
		margin-top: 12px;
		text-decoration: underline;
		font-weight: 700;
	}
`;

export const WrapperSkeleton = styled.div`
	padding: 22px 15px;
	display: flex;
	flex-direction: column;
	gap: 5px;
`;

export const CardContainer = styled.div`
	padding: 22px 15px;
	width: 320px;
	height: auto;
	background-color: #f5f7fa;
`;

export const ContainerUpperHeader = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 12px;
`;
